import * as React from "react";
import './Pick.css';
import './Situation.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import addColumnPointer from '../../images/template/addColumnPointer.png'
import Kozijnen from "./situation/Kozijnen";
import Luiken from "./situation/Luiken";
import Breedte from "./situation/Breedte";
import DraaitypeWindow from "./situation/DraaitypeWindow";
import Hoogte from "./situation/Hoogte";
import {DraaiType, HengType, LuikType, MontageType} from "../../Model";
import MontageWindow from "./situation/MontageWindow";
import HengtypeWindow from "./situation/HengtypeWindow";
import MaatA from "./situation/MaatA";
import MaatD from "./situation/MaatD";
import MaatK from "./situation/MaatK";
import MaatM from "./situation/MaatM";
import MaatT from "./situation/MaatT";
import MaatS from "./situation/MaatS";
import Error from "./situation/Error";
import {hasValue, validateAmountWithRotationType, validateHangPoints, validateKlampen} from "../../util/Validator";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import MaatY from "./situation/MaatY";

SituationPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
}

const requiredTypes = ["kozijnen", "luiken", "breedte", "hoogte", "montage", "draaitype", "hengtype", "maatD", "maatM", "maatT"]
const requiredTypesWhenKozijnMontage = ["maatA", "maatK"]
const requiredTypesWhenOpgeklampt = ["maatY"]

export default function SituationPick(props) {
    const currentValue = props.allValues.SituationPick;
    const klamptZichtbaar = props.allValues.TypePick === LuikType.VENSTERLUIK_VISIBLE_CLAMS;
    const klamptOnzichtbaar = props.allValues.TypePick === LuikType.VENSTERLUIK_INVISIBLE_CLAMS;
    let klampen = "none";
    if (klamptZichtbaar) {
        klampen = "visible"
    } else if (klamptOnzichtbaar) {
        klampen = "invisible"
    }    const hasStijlbreedte = props.allValues.TypePick === LuikType.LOUVRELUIK || props.allValues.TypePick === LuikType.PANEELLUIK;

    const [selected, setSelected] = useState({property: "", row: 0});
    const [wrongFields, setWrongFields] = useState([]);
    const [warnings, setWarnings] = useState([]);

    useEffect(() => {
        if (currentValue == null) {
            props.handlePageChange({
                row: 1,
                currentRow: -1,
                currentColumn: 0,
                data: [{montage: MontageType.MUUR, draaitype: DraaiType.AL, hengtype: HengType.T2}]
            })
        }
    }, []);

    const addColumn = (c) => () => {
        const newAmount = Math.min(c.row + 1, 7);
        const data = JSON.parse(JSON.stringify(c.data));
        while (data.length < newAmount) {
            data.push({montage: MontageType.MUUR, draaitype: DraaiType.AL, hengtype: HengType.T2});
        }
        props.handlePageChange({row: newAmount, currentRow: c.currentRow, currentColumn: c.currentColumn, data});
    }

    const removeColumn = (c) => () => {
        let newAmount = Math.max(c.row - 1, 1);
        props.handlePageChange({
            row: newAmount,
            currentRow: c.currentRow,
            currentColumn: c.currentColumn,
            data: c.data.slice(0, newAmount)
        });
    }

    const changedInput = (row, property) => value => {
        if (value.currentTarget) {
            value = value.currentTarget.value;
        }
        const data = JSON.parse(JSON.stringify(currentValue.data));
        data[row][property] = value;
        props.handlePageChange({
            row: currentValue.row,
            currentRow: currentValue.currentRow,
            currentColumn: currentValue.currentColumn,
            data
        });
    }

    const isWrongField = (row, property) => wrongFields.filter(field => field === row + property).length > 0

    const onFocus = (row, property) => () => {
        setSelected({property: property, row: row});
    }

    const onBlur = (row, property) => () => {
        const val = getIf(currentValue.data, row, property);
        if (!hasValue(val)) {
            if (!isWrongField(row, property)) {
                setWrongFields([...wrongFields, row + property]);
            }
        } else {
            if (isWrongField(row, property)) {
                setWrongFields(wrongFields.filter(field => field !== row + property));
            }
        }
    }

    const blurAll = () => {
        const toAdd = []
        const toRemove = [];

        function blur(row, property) {
            const val = getIf(currentValue.data, row, property);
            if (!hasValue(val)) {
                if (!isWrongField(row, property)) {
                    toAdd.push(row + property);
                }
            } else {
                if (isWrongField(row, property)) {
                    toRemove.push(row + property);
                }
            }
        }

        for (let i = 0; i < currentValue.row; i++) {
            for (let type of requiredTypes) {
                blur(i, type);
            }
            for (let type of requiredTypesWhenKozijnMontage) {
                blur(i, type);
            }
            for (let type of requiredTypesWhenOpgeklampt) {
                blur(i, type);
            }

            blur(i, "maatS");
        }

        setTimeout(() => setWrongFields([...wrongFields.filter(field => !toRemove.includes(field)), ...toAdd]), 1);
    }

    if (currentValue == null) {
        return <div></div>
    }

    const getProps = (index, property, disabled = false) => {
        return {
            className: "input-field " + (isWrongField(index, property) && !disabled ? "wrong" : ""),
            value: getIf(currentValue.data, index, property),
            onFocus: onFocus(index, property),
            onChange: changedInput(index, property),
            onBlur: onBlur(index, property),
            disabled: disabled
        }
    }

    const isMuurMontage = (index) => getIf(currentValue.data, index, "montage") === MontageType.MUUR;

    const onNext = () => {
        blurAll();
        const _warnings = [];
        let invalid = false;

        for (const [i, row] of currentValue.data.entries()) {
            const found = requiredTypes.filter(type => !hasValue(row[type]));
            if (row.montage !== MontageType.MUUR) {
                found.push(...requiredTypesWhenKozijnMontage.filter(type => !hasValue(row[type])));
            }

            if (klamptOnzichtbaar || klamptZichtbaar) {
                found.push(...requiredTypesWhenOpgeklampt.filter(type => !hasValue(row[type])));
            }

            if (found.length > 0) {
                invalid = true;
                continue;
            }

            _warnings.push(...validateAmountWithRotationType(i, row.draaitype, row.kozijnen, row.luiken));
            _warnings.push(...validateHangPoints(i, row.hengtype, row.hoogte));
            _warnings.push(...validateKlampen(i, row.hengtype, props.allValues.TypePick));
        }

        if (currentValue.data[0] == null || currentValue.data[0]["maatS"] == null || currentValue.data[0]["maatS"] === "") {
            if (hasStijlbreedte) {
                invalid = true;
            }
        }

        if (invalid || _warnings.length > 0) {
            setSelected({property: "error", row: -1});
            setWarnings(_warnings);
        } else {
            setWarnings([]);
            props.handleNextPage();
        }
    }

    const getWindow = ({property, row}) => {
        if (!property) {
            return null;
        }
        const _currentValue = getIf(currentValue.data, row, property);
        const currentMontageValue = getIf(currentValue.data, row, "montage");
        const onChange = changedInput(row, property);
        switch (property) {
            case "kozijnen":
                return <Kozijnen/>;
            case "luiken":
                return <Luiken/>;
            case "breedte":
                return <Breedte/>;
            case "hoogte":
                return <Hoogte/>;
            case "montage":
                return <MontageWindow currentValue={_currentValue} onChange={onChange}/>;
            case "draaitype":
                return <DraaitypeWindow currentValue={_currentValue} onChange={onChange}/>;
            case "hengtype":
                return <HengtypeWindow currentValue={_currentValue} onChange={onChange}/>;
            case "maatA":
                return <MaatA/>;
            case "maatY":
                return <MaatY isMuurMontage={currentMontageValue === MontageType.MUUR} klampen={klampen}/>;
            case "maatD":
                return <MaatD isMuurMontage={currentMontageValue === MontageType.MUUR} klampen={klampen}/>;
            case "maatK":
                return <MaatK/>;
            case "maatM":
                return <MaatM isMuurMontage={currentMontageValue === MontageType.MUUR}/>;
            case "maatT":
                return <MaatT isMuurMontage={currentMontageValue === MontageType.MUUR}/>;
            case "maatS":
                return <MaatS/>;
            case "error":
                return <Error warnings={warnings} onSkip={props.handleNextPage}/>;
            default:
                return null;
        }
    }

    return (
        <div className="page">
            <AppHeader title="Situatie"/>

            <div className="page-middle">
                <div id="magic-window">
                    <div className="innerWindow">
                        {getWindow(selected) || <div>
                            <h1 style={{margin: "0"}}>Wat is uw situatie?</h1>
                            <div className="addtextMore" style={{height: "auto"}}>
                                Hier kunt u per kozijn of per situatie de benodigde gegevens invullen.<br/>
                                <br/>
                                Extra informatie over het geselecteerde veld wordt vanzelf weergegeven.<br/>
                                <br/>
                                U kunt 7 kozijnen of situaties aanvragen.<br/>
                                Gebruik hiervoor de knoppen onder het invulscherm.
                            </div>
                        </div>}
                    </div>
                </div>

                <hr/>
                {currentValue.row > 1
                    ? null
                    : <div id="addSituationPointer"><img src={addColumnPointer} alt=""/></div>
                }
                <div id="table-wrapper">
                    <table id="tableDetails">
                        <thead>
                        <tr className="situationCenter">
                            <td className="situationCenter" style={{width: "130px"}}>Situatie</td>
                            <td className="situationCenter">A</td>
                            <td className="situationCenter">B</td>
                            <td className="situationCenter">C</td>
                            <td className="situationCenter">D</td>
                            <td className="situationCenter">E</td>
                            <td className="situationCenter">F</td>
                            <td className="situationCenter">G</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Aantal kozijnen</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "kozijnen")}
                                                   type="number"
                                                   tabIndex="1"
                                                   min="1"/></td>)}
                        </tr>
                        <tr>
                            <td>Aantal luiken</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "luiken")}
                                                   type="number"
                                                   tabIndex="2"
                                                   min="1"/></td>)}
                        </tr>
                        <tr>
                            <td>Luik breedte</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "breedte")}
                                                   type="number"
                                                   tabIndex="3"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>
                        <tr>
                            <td>Luik hoogte</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "hoogte")}
                                                   type="number"
                                                   tabIndex="4"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>
                        <tr>
                            <td>Montage</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><select {...getProps(i, "montage")} tabIndex="5">
                                    <option value={MontageType.MUUR}>Muur</option>
                                    <option value={MontageType.KOZIJN}>Kozijn</option>
                                </select></td>)}
                        </tr>
                        <tr>
                            <td>Draai type</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><select {...getProps(i, "draaitype")} tabIndex="6">
                                    <option value={DraaiType.AL}>Type AL</option>
                                    <option value={DraaiType.AR}>Type AR</option>
                                    <option value={DraaiType.B}>Type B</option>
                                    <option value={DraaiType.CL}>Type CL</option>
                                    <option value={DraaiType.CR}>Type CR</option>
                                    <option value={DraaiType.DL}>Type DL</option>
                                    <option value={DraaiType.DR}>Type DR</option>
                                    <option value={DraaiType.E}>Type E</option>
                                    <option value={DraaiType.EL}>Type EL</option>
                                    <option value={DraaiType.ER}>Type ER</option>
                                    <option value={DraaiType.F}>Type F</option>
                                    <option value={DraaiType.FL}>Type FL</option>
                                    <option value={DraaiType.FR}>Type FR</option>
                                    <option value={DraaiType.ALO}>Type ALO</option>
                                    <option value={DraaiType.ARO}>Type ARO</option>
                                    <option value={DraaiType.BLO}>Type BLO</option>
                                    <option value={DraaiType.BRO}>Type BRO</option>
                                </select></td>)}
                        </tr>
                        <tr>
                            <td>Hengtype</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><select {...getProps(i, "hengtype")} tabIndex="7">
                                    <option value={HengType.T2}>T2</option>
                                    <option value={HengType.L2}>L2</option>
                                    <option value={HengType.H2}>H2</option>
                                    <option value={HengType.T3}>T3</option>
                                    <option value={HengType.L3}>L3</option>
                                    <option value={HengType.HT3}>HT3</option>
                                    <option value={HengType.LT3}>LT3</option>
                                </select></td>)}
                        </tr>
                        <tr>
                            <td>Maat A</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "maatA", isMuurMontage(i))}
                                                   type="number"
                                                   tabIndex="8"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>
                        {klamptZichtbaar || klamptOnzichtbaar ?
                            <tr>
                                <td>Maat Y</td>
                                {range(currentValue.row).map(i =>
                                    <td key={i}><input {...getProps(i, "maatY")}
                                                       type="number"
                                                       tabIndex="9"
                                                       min="1"
                                                       placeholder="in mm"/></td>)}
                            </tr> : null}
                        <tr>
                            <td>Maat D</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "maatD")}
                                                   type="number"
                                                   tabIndex="9"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>
                        <tr>
                            <td>Maat K</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "maatK", isMuurMontage(i))}
                                                   type="number"
                                                   tabIndex="10"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>
                        <tr>
                            <td>Maat M</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "maatM")}
                                                   type="number"
                                                   tabIndex="11"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>
                        <tr>
                            <td>Maat T</td>
                            {range(currentValue.row).map(i =>
                                <td key={i}><input {...getProps(i, "maatT")}
                                                   type="number"
                                                   tabIndex="12"
                                                   min="1"
                                                   placeholder="in mm"/></td>)}
                        </tr>

                        {hasStijlbreedte ?
                            <tr className="loneCell">
                                <td>Maat S</td>
                                <td className="loneCell">
                                    <input type="number" {...getProps(0, "maatS")}
                                           min="0" tabIndex="999" placeholder="in mm"/>
                                </td>
                            </tr> : null}
                        </tbody>
                    </table>
                </div>
                <div id="button-box">
                    <button type="button" id="btnAddCol" onClick={addColumn(currentValue)}>Voeg situatie toe</button>
                    <button type="button" id="btnDelCol" onClick={removeColumn(currentValue)}>Verwijder laatste situatie
                    </button>
                </div>
            </div>
            <AppFooter onNext={onNext}
                       onPrevious={props.handlePreviousPage}
                       enableNext={true}/>
        </div>
    );
}

function range(size) {
    return [...Array(size).keys()];
}

function getIf(array, index, key) {
    if (array[index] == null || array[index][key] == null) {
        return "";
    }
    return array[index][key];
}
